import React, { useEffect, useState } from "react";

import { isEmpty } from "ramda";

import npiApi from "apis/npi";
import {
  Button,
  Table,
  Typography,
  Pagination,
  SubHeader,
  PageLoader,
} from "clearsense-ui/components";

import { NPI_TABLE_COLUMNS, DEFAULT_PAGE_SIZE } from "../constants";

const Results = ({ searchParams, setSearchParams }) => {
  const [npiData, setNpiData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [totalRecordsCount, setTotalRecordsCount] = useState(0);

  const fetchNPIRecords = async () => {
    try {
      setLoading(true);
      const {
        data: {
          result: { matches, npi_data_count },
        },
      } = await npiApi.search({
        ...searchParams,
        page: currentPage,
        per_page: currentPageSize,
      });
      setNpiData(matches);
      setTotalRecordsCount(npi_data_count);
    } catch (error) {
      logger.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNPIRecords();
  }, [currentPage, currentPageSize]);

  if (loading) {
    return <PageLoader />;
  }

  return (
    <div className="cs-ui-container">
      <div className="mx-8">
        <SubHeader
          className="mt-8"
          breadcrumbs={[
            { label: "NPI Registry", link: "#" },
            { label: "Results", link: "#" },
          ]}
        />
        <hr></hr>
        {isEmpty(npiData) ? (
          <div className="mt-4">
            <Typography data-cy="npi-no-matching-record-text" style="h3">
              No matching records found.
            </Typography>
          </div>
        ) : (
          <>
            <Typography style="large" className="mt-4">
              The following NPI(s) contain information matching your search
              criteria. Please select the NPI to view all the data associated
              with the NPI.
            </Typography>
            <div className="flex flex-col justify-between flex-grow  mt-4 mr-0 cs-ui-table-background">
              <Table
                fixedHeight
                columnData={NPI_TABLE_COLUMNS}
                rowData={npiData}
                rowKey="id"
                className="whitespace-pre-wrap"
                data-cy="npi-search-result-table"
              ></Table>
              <Pagination
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pageSize={currentPageSize}
                setPageSize={setCurrentPageSize}
                showResultsPerPage
                totalRecordsCount={totalRecordsCount}
                className="px-8 py-2"
              />
            </div>
          </>
        )}
        <div className="flex justify-center mt-6">
          <Button
            label="Start a new search"
            onClick={() => setSearchParams({})}
            data-cy="npi-start-new-search-button"
          />
        </div>
      </div>
    </div>
  );
};

export default Results;
